import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  Button,
  Icon,
  ModalContainer,
  ModalService,
  ToastService,
} from '@client';
import LoginModal from '../../pages/auth/login/modal/login-modal.modal';

@Component({
  selector: 'app-login-prompt-modal',
  imports: [CommonModule, Icon, ModalContainer, Button],
  templateUrl: './login-prompt-modal.component.html',
  styleUrl: './login-prompt-modal.component.scss',
})
export class LoginPromptModalComponent {
  modalService = inject(ModalService);
  toastService = inject(ToastService);

  router = inject(Router);

  login() {
    this.modalService.close();
    this.modalService.create(LoginModal);
  }

  close() {
    this.modalService.close();
  }
}
